var map = {
	"./Coccoliths_on_Foraminifera_01_016 (1).jpg": 5949,
	"./Coccoliths_on_Foraminifera_01_016 (2).jpg": 9863,
	"./Coocolith on Globigerina_01.jpg": 2533,
	"./Coocolith on Globigerina_02.jpg": 7934,
	"./Coocolith on Globigerina_03.jpg": 8498,
	"./Coocolith on Globigerina_08.jpg": 8207,
	"./Coocolithophorid_01.jpg": 9514,
	"./Coocolithophorid_03.jpg": 2059,
	"./Foraminifera-01.jpg": 9869,
	"./Foraminifera_01_009.jpg": 9729,
	"./Foraminifera_01_010.jpg": 2447,
	"./Foraminifera_01_011.jpg": 1927,
	"./Foraminifera_01_012.jpg": 6473,
	"./Foraminifera_01_013.jpg": 3390,
	"./Foraminifera_coccolith-01_004.jpg": 7475,
	"./Foraminifera_coccolith-01_005.jpg": 3027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3412;